var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 66.5V17h66v49.5H9z",
    stroke: "#fff",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 78.5h66.5v-50M19.5 27v30M65 27v30",
    stroke: "#fff",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.532 58.42v-3.24c-1.632-.36-3.024-1.08-4.176-2.16-1.152-1.08-2.004-2.436-2.556-4.068l3.996-1.476c.504 1.176 1.2 2.112 2.088 2.808a4.772 4.772 0 003.024 1.044c1.176 0 2.112-.3 2.808-.9.696-.624 1.044-1.488 1.044-2.592 0-.576-.12-1.08-.36-1.512-.24-.456-.648-.864-1.224-1.224a9.753 9.753 0 00-1.512-.828 48.263 48.263 0 00-1.944-.792c-.888-.336-1.56-.6-2.016-.792a31.443 31.443 0 01-1.836-.972c-.744-.456-1.308-.912-1.692-1.368-.36-.456-.696-1.056-1.008-1.8-.288-.744-.432-1.572-.432-2.484 0-1.608.504-3 1.512-4.176 1.032-1.2 2.46-1.98 4.284-2.34v-2.88h4.212v2.916c1.416.336 2.568.96 3.456 1.872.912.888 1.56 1.992 1.944 3.312l-3.888 1.296c-.696-1.728-2.016-2.592-3.96-2.592-.984 0-1.752.228-2.304.684-.552.456-.828 1.092-.828 1.908 0 .36.084.696.252 1.008.168.312.36.576.576.792.24.192.588.408 1.044.648.48.24.876.42 1.188.54.312.12.792.3 1.44.54.792.312 1.38.552 1.764.72.384.168.936.432 1.656.792.72.36 1.272.732 1.656 1.116.384.36.792.816 1.224 1.368.432.528.744 1.152.936 1.872.192.696.288 1.476.288 2.34 0 2.04-.6 3.708-1.8 5.004-1.2 1.296-2.748 2.112-4.644 2.448v3.168h-4.212z",
    fill: "#fff"
  })));
}

export default SvgMoney;